import { PropertyName, ValueIterateeCustom } from 'lodash';
import { keyBy, merge, values } from 'lodash/fp';

interface IArrayItem {
  id: string | number;
  order: number;
}

export function reorderArray<T extends IArrayItem>(arr: T[], itemId: string, newOrder: number): T[] {
  const offset = arr[0].order;
  const item = arr.find((i) => i.id === itemId);
  if (item) {
    const newArray = arr.filter((i) => i.id !== itemId);
    newArray.splice(newOrder - offset, 0, item);
    return refreshOrderProp(newArray, offset);
  }
  return arr;
}

export function refreshOrderProp<T extends IArrayItem>(arr: T[], offset = 0): T[] {
  return arr.map((a, i) => ({ ...a, order: i + offset }));
}

export function outerJoinOn<L, R>(
  leftKey: ValueIterateeCustom<L, PropertyName>,
  rightKey: ValueIterateeCustom<R, PropertyName>,
  left: L[],
  right: R[]
): (L & R)[] {
  return values(merge(keyBy(leftKey, left), keyBy(rightKey, right)));
}
